module.exports = __webpack_public_path__ + "static/media/010-girl-1.842ae80d.svg";